/**
 * Exports all available types of filters
 */
export default {
    region: 'region',
    ageGroup: 'ageGroup',
    bacterium: 'bacterium',
    antibiotic: 'antibiotic',
    substanceClass: 'substanceClass',
}


// WEBPACK FOOTER //
// ./js/models/filters/filterTypes.js